import { MicOff } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
const IOS = /iPhone|iPad|iPod/.test(ua) || (typeof navigator !== "undefined" && navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
const ANDROID = /Android/.test(ua);

const STEPS = IOS ? [
  "Apri l'app «Impostazioni» dell'iPhone.",
  "Scorri e tocca «Safari» (oppure «K Gestionale» se l'hai installata sulla Home).",
  "Tocca «Microfono» e scegli «Consenti».",
  "Torna qui e premi «Riprova».",
] : ANDROID ? [
  "Tocca il lucchetto accanto all'indirizzo in alto. Se usi l'app installata: tieni premuta l'icona K Gestionale → «Info app».",
  "Apri «Autorizzazioni» → «Microfono».",
  "Scegli «Consenti».",
  "Torna qui e premi «Riprova».",
] : [
  "Clicca il lucchetto a sinistra dell'indirizzo del sito.",
  "Alla voce «Microfono» scegli «Consenti».",
  "Ricarica la pagina e premi «Riprova».",
];

const INFO = {
  denied: ["Il microfono è bloccato", "Per parlare con l'assistente serve il permesso al microfono. Si attiva in pochi passi:"],
  nodevice: ["Nessun microfono trovato", "Collega un microfono (o usa il telefono) e riprova. Intanto puoi scrivere il messaggio."],
  busy: ["Il microfono è già in uso", "Chiudi chiamate o altre app che usano il microfono, poi riprova."],
  unsupported: ["Questo browser non registra la voce", "Aggiorna il browser oppure usa Chrome o Safari. Intanto puoi scrivere il messaggio."],
};

// Spiega con parole semplici perché il microfono non parte e come sbloccarlo.
export const MicHelpDialog = ({ kind, onClose, onRetry }) => {
  const [title, text] = INFO[kind] || INFO.denied;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="mic-help-dialog">
        <DialogHeader>
          <div className="w-11 h-11 rounded-xl bg-destructive/10 text-destructive flex items-center justify-center mb-1"><MicOff className="w-5 h-5" /></div>
          <DialogTitle className="font-heading" data-testid="mic-help-title">{title}</DialogTitle>
          <DialogDescription className="text-base">{text}</DialogDescription>
        </DialogHeader>
        {kind === "denied" && (
          <ol className="space-y-2" data-testid="mic-help-steps">
            {STEPS.map((s, i) => (
              <li key={s} className="flex gap-3 text-[15px]"><span className="w-7 h-7 rounded-full bg-primary text-primary-foreground text-sm font-bold flex items-center justify-center shrink-0">{i + 1}</span><span className="pt-0.5">{s}</span></li>
            ))}
          </ol>
        )}
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onClose} data-testid="mic-help-close">Scrivo il messaggio</Button>
          {kind !== "unsupported" && <Button onClick={onRetry} data-testid="mic-help-retry">Riprova</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default MicHelpDialog;
